<div class="product-params">
  @if(attributes?.length > 0){
  @for(attribute of (showAllAttributes ? attributes : attributes.slice(0, 10)); track attribute.value){
  <div class="line">
    <span class="label">{{attribute.name}}</span>
    <span class="value">{{attribute.value}}</span>
  </div>
  }
  @if(attributes?.length > 10){
  @if(!showAllAttributes){
  <a pRipple class="show-more-link" (click)="toggleShowMore()">Show more</a>
  } @else {
  <a pRipple class="show-more-link" (click)="toggleShowLess()">Show less</a>
  }
  }

  } @else {

  }

</div>
